import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'
import { TgtLogger } from '@measurement/opentelemetry-web'

export const IndirectItemSearch = () => {
  return (
    <MicroFrontEnd
      name="IndirectItemSearch"
      src={apiConfig.microFrontEnds.IndirectItemSearch}
      useErrorBoundary
      logger={TgtLogger}
    />
  )
}
export default IndirectItemSearch
